export function suggestedAllocation(invoice, depositAmount, allocation = {}) {
  if (!invoice?.eligible || !Number.isFinite(Number(invoice.available_in_payment_currency))) return null
  const used = Object.values(allocation).reduce((total, value) => total + Number(value || 0), 0)
  const amount = Math.min(Number(invoice.available_in_payment_currency), Math.max(0, Number(depositAmount) - used))
  return amount > 0 ? Math.floor((amount + Number.EPSILON) * 100) / 100 : null
}

export function addInvoiceAllocation(invoice, depositAmount, allocation = {}) {
  const id = invoice.invoice_number
  if (!id || Object.hasOwn(allocation, id)) return allocation
  const amount = suggestedAllocation(invoice, depositAmount, allocation)
  return amount === null ? allocation : { ...allocation, [id]: amount }
}

export function contextVersions(context, previous = {}) {
  const versions = { ...previous }
  for (const invoice of [...(context?.items || []), ...(context?.referenced_invoices || [])]) {
    if (invoice.balance_version != null) versions[invoice.invoice_number] = invoice.balance_version
  }
  return versions
}

export function allocationContextValid(allocation, versions) {
  return Object.keys(allocation).length > 0 && Object.keys(allocation).every((id) => versions[id] != null)
}
